'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SocialTwitterIcon = function SocialTwitterIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Twitter' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M9.2172,18.0954 C14.8776,18.0954 17.9736,13.4058 17.9736,9.339 C17.9736,9.2058 17.9736,9.0732 17.9646,8.9412 C18.5668988,8.50554651 19.0868133,7.96612764 19.5,7.3482 C18.9383274,7.59708106 18.3424976,7.76029719 17.7324,7.8324 C18.3748464,7.44778923 18.8556741,6.84286319 19.0854,6.1302 C18.4812945,6.48867319 17.8203877,6.74130721 17.1312,6.8772 C16.1772497,5.86283657 14.6614316,5.61456755 13.4337296,6.27160796 C12.2060275,6.92864836 11.571765,8.32759544 11.8866,9.684 C9.41213744,9.55994972 7.10668547,8.39119396 5.544,6.4686 C4.72717365,7.87478684 5.14439273,9.67371569 6.4968,10.5768 C6.00704472,10.5622845 5.52796762,10.4301679 5.1,10.1916 C5.1,10.2042 5.1,10.2174 5.1,10.2306 C5.10040088,11.6955558 6.13305089,12.9573211 7.569,13.2474 C7.11592176,13.370964 6.64054835,13.3890266 6.1794,13.3002 C6.58256876,14.5538537 7.73794474,15.4126703 9.0546,15.4374 C7.96484102,16.2938592 6.61863571,16.7587966 5.2326,16.7574 C4.98774214,16.7569299 4.74312244,16.7421045 4.5,16.713 C5.90738157,17.6161659 7.54494804,18.0952302 9.2172,18.093"
    })]
  }));
};
SocialTwitterIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SocialTwitterIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Twitter'",
        "computed": false
      },
      "required": false
    }
  }
};
var SocialTwitterIcon$1 = SocialTwitterIcon;

exports.default = SocialTwitterIcon$1;
//# sourceMappingURL=SocialTwitterIcon.js.map
